import { createSlice } from '@reduxjs/toolkit';
import { gamesData } from '../../data/games';

const initialState = {
  allGames: gamesData,
  filteredGames: gamesData,
  selectedGame: null,
  filters: {
    platform: 'all',
    genre: 'all',
    status: 'all',
    search: '',
  },
  sortBy: 'featured',
  favorites: [],
};

const gamesSlice = createSlice({
  name: 'games',
  initialState,
  reducers: {
    setSelectedGame: (state, action) => {
      state.selectedGame = action.payload;
    },
    setFilter: (state, action) => {
      const { filterType, value } = action.payload;
      state.filters[filterType] = value;
      state.filteredGames = applyFilters(state.allGames, state.filters);
    },
    clearFilters: (state) => {
      state.filters = {
        platform: 'all',
        genre: 'all',
        status: 'all',
        search: '',
      };
      state.filteredGames = state.allGames;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
      state.filteredGames = sortGames(state.filteredGames, action.payload);
    },
    toggleFavorite: (state, action) => {
      const gameId = action.payload;
      const index = state.favorites.indexOf(gameId);
      if (index === -1) {
        state.favorites.push(gameId);
      } else {
        state.favorites.splice(index, 1);
      }
    },
    setSearchQuery: (state, action) => {
      state.filters.search = action.payload;
      state.filteredGames = applyFilters(state.allGames, state.filters);
    },
  },
});

// Helper function to apply filters
const applyFilters = (games, filters) => {
  return games.filter((game) => {
    const matchesPlatform =
      filters.platform === 'all' || game.platforms.includes(filters.platform);
    const matchesGenre =
      filters.genre === 'all' || game.genres.includes(filters.genre);
    const matchesStatus =
      filters.status === 'all' || game.status === filters.status;
    const matchesSearch =
      filters.search === '' ||
      game.title.toLowerCase().includes(filters.search.toLowerCase()) ||
      game.description.toLowerCase().includes(filters.search.toLowerCase());

    return matchesPlatform && matchesGenre && matchesStatus && matchesSearch;
  });
};

// Helper function to sort games
const sortGames = (games, sortBy) => {
  const sorted = [...games];
  switch (sortBy) {
    case 'featured':
      return sorted.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0));
    case 'title':
      return sorted.sort((a, b) => a.title.localeCompare(b.title));
    case 'rating':
      return sorted.sort((a, b) => (b.rating || 0) - (a.rating || 0));
    case 'newest':
      return sorted.sort((a, b) => b.id - a.id);
    default:
      return sorted;
  }
};

export const {
  setSelectedGame,
  setFilter,
  clearFilters,
  setSortBy,
  toggleFavorite,
  setSearchQuery,
} = gamesSlice.actions;

export const selectAllGames = (state) => state.games.allGames;
export const selectFilteredGames = (state) => state.games.filteredGames;
export const selectSelectedGame = (state) => state.games.selectedGame;
export const selectFilters = (state) => state.games.filters;
export const selectSortBy = (state) => state.games.sortBy;
export const selectFavorites = (state) => state.games.favorites;

export default gamesSlice.reducer;
